import styled from 'styled-components/macro';
import { lightGrey } from '../styling/colours';
import { medium } from '../styling/spacing';

export const Panel = styled.div`
  background-color: ${lightGrey};
  padding: ${medium};
`;
